export default __webpack_public_path__ + "static/media/logo.5fe6bdf1.png";